//路由列表
export default [{
    path: '/home',
    name: 'home',
    meta: {
        title: '首页',
    },
    component: () => import('../views/home/Home.vue'),
}, /*{
    path: '/usdt_daifu',
    name: 'usdt_daifu',
    meta: {
        title: 'USDT代付',
    },
    component: () => import('../views/usdt_daifu/UsdtDaifu.vue'),
},*/ {
    path: '/index',
    name: 'index',
    meta: {
        title: '数据统计',
        requiredAuth: true
    },
    component: () => import('../views/index/Index.vue'),
},
// 支付管理
    {
        path: '/payment',
        name: 'payment',
        meta: {
            title: '支付管理',
            requiredAuth: true
        },
        component: () => import('../views/payment/Payment.vue'),
    },
    {
        path: '/payment_groups',
        name: 'payment_groups',
        meta: {
            title: '支付分组',
            requiredAuth: true
        },
        component: () => import('../views/payment/PaymentGroups.vue'),
    },
    {
        path: '/cdkey',
        name: 'cdkey',
        meta: {
            title: 'cdkey管理',
            requiredAuth: true
        },
        component: () => import('../views/cdkey/CDkey.vue'),
    },
    {
        path: '/cdkey/:id',
        name: 'cdkey_details',
        meta: {
            title: 'cdkey详情',
            requiredAuth: true
        },
        props: true,
        component: () => import('../views/cdkey/KeysList.vue'),
    },
// 盒子管理
    {
        path: '/case',
        name: 'case',
        meta: {
            title: '盒子管理',
            requiredAuth: true
        },
        component: () => import('../views/case/Case.vue'),
    },
    {
        path: '/case/:id',
        name: 'case_prize',
        meta: {
            title: '盒子奖品',
            requiredAuth: true
        },
        props: true,
        component: () => import('../views/case/CasePrize.vue'),
    },
    {
        path: '/case_pv',
        name: 'case_pv',
        meta: {
            title: '隐藏盒子管理',
            requiredAuth: true
        },
        component: () => import('../views/case/CasePrivate'),
    },
    {
        path: '/case_private/:id',
        name: 'case_private_details',
        meta: {
            title: '隐藏盒子详情',
            requiredAuth: true
        },
        props: true,
        component: () => import('../views/case/CasePrizePrivate.vue'),
    },
    {
        path: '/case_sold_out',
        name: 'case_sold_out',
        meta: {
            title: '下架盒子',
            requiredAuth: true
        },
        component: () => import('../views/case/CaseSoldOut.vue'),
    },
    {
        path: '/box_group',
        name: 'box_group',
        meta: {
            title: '盒子分组',
            requiredAuth: true
        },
        component: () => import('../views/boxgroup/BoxGroup.vue'),
    },
    {
        path: '/category',
        name: 'category',
        meta: {
            title: '盒子分类',
            requiredAuth: true
        },
        component: () => import('../views/category/Category.vue'),
    },
    {
        path: '/case_guaranteed_overview',
        name: 'case_guaranteed_overview',
        meta: {
            title: '保底总览',
            requiredAuth: true
        },
        component: () => import('../views/case/guaranteed/CaseGuaranteedOverview.vue'),
    },
    {
        path: '/case_coefficient_config',
        name: 'case_coefficient_config',
        meta: {
            title: '系数配置',
            requiredAuth: true
        },
        component: () => import('../views/case/guaranteed/CaseCoefficientConfig.vue'),
    },
    {
        path: '/case_guaranteed_config',
        name: 'case_guaranteed_config',
        meta: {
            title: '常规配置',
            requiredAuth: true
        },
        component: () => import('../views/case/guaranteed/CaseGuaranteedConfig.vue'),
    },
    {
        path: '/case_guaranteed_pool_config',
        name: 'case_guaranteed_pool_config',
        meta: {
            title: '水池配置',
            requiredAuth: true
        },
        component: () => import('../views/case/guaranteed/CaseGuaranteedPoolConfig.vue'),
    },
    {
        path: '/user_guaranteed',
        name: 'user_guaranteed',
        meta: {
            title: '保底用户数据',
            requiredAuth: true
        },
        component: () => import('../views/case/guaranteed/UserGuaranteed.vue'),
    },
    {
        path: '/user_guaranteed_details',
        name: 'user_guaranteed_details',
        meta: {
            title: '保底用户数据详情',
            requiredAuth: true
        },
        component: () => import('../views/case/guaranteed/UserGuaranteedDetails.vue'),
    },
    {
        path: '/case_guaranteed_box',
        name: 'case_guaranteed_box',
        meta: {
            title: '盒子盈亏',
            requiredAuth: true
        },
        component: () => import('../views/case/guaranteed/CaseGuaranteedBox.vue'),
    },
    {
        path: '/case_guaranteed_box_details',
        name: 'case_guaranteed_box_details',
        meta: {
            title: '盒子盈亏详情',
            requiredAuth: true
        },
        component: () => import('../views/case/guaranteed/CaseGuaranteedBoxDetails.vue'),
    },
// 奖品管理
    {
        path: '/prize',
        name: 'prize',
        meta: {
            title: '奖品管理',
            requiredAuth: true
        },
        component: () => import('../views/prize/Prize.vue'),
    },
    {
        path: '/price_config',
        name: 'price_config',
        meta: {
            title: '价格配置',
            requiredAuth: true
        },
        component: () => import('../views/prize/PriceConfig.vue'),
    },
// 商城管理
    {
        path: '/shop',
        name: 'shop',
        meta: {
            title: '商城管理',
            requiredAuth: true
        },
        component: () => import('../views/shop/Shop.vue'),
    },
    {
        path: '/shop_record',
        name: 'shop_record',
        meta: {
            title: '商城购买记录',
            requiredAuth: true
        },
        component: () => import('../views/shop/ShopRecord'),
    },
    // 用户管理
    {
        path: '/user',
        name: 'user',
        meta: {
            title: '用户管理',
            requiredAuth: true
        },
        component: () => import('../views/user/User.vue'),
    },
    {
        path: '/user_score_rule',
        name: 'user_score_rule',
        meta: {
            title: '用户等级分布',
            requiredAuth: true
        },
        component: () => import('../views/user/UserScoreRule.vue'),
    },
    {
        path: '/user/:id',
        name: 'user_details',
        meta: {
            title: '用户详情',
            requiredAuth: true
        },
        props: true,
        component: () => import('../views/user/UserDetail.vue'),
    },
    {
        path: '/user_anchor_stat',
        name: 'user_anchor_stat',
        meta: {
            title: '主播拉新',
            requiredAuth: true
        },
        component: () => import('../views/user/UserAnchorStat.vue'),
    },
    {
        path: '/user_benefit_statistical',
        name: 'user_benefit_statistical',
        meta: {
            title: '用户福利查询',
            requiredAuth: true
        },
        component: () => import('../views/user/UserBenefitStatistical'),
    },
    {
        path: '/associated_real_name',
        name: 'associated_real_name',
        meta: {
            title: '用户关联',
            requiredAuth: true
        },
        component: () => import('../views/user/AssociatedRealName.vue'),
    },
    {
        path: '/associated_real_name_activity',
        name: 'associated_real_name_activity',
        meta: {
            title: '用户关联-活动币',
            requiredAuth: true
        },
        component: () => import('../views/user/AssociatedRealNameActivity.vue'),
    },
    {
        path: '/old_users',
        name: 'old_users',
        meta: {
            title: '老用户查询',
            requiredAuth: true
        },
        component: () => import('../views/user/OldUsers.vue'),
    },
    {
        path: '/query_box',
        name: 'query_box',
        meta: {
            title: '箱子查询',
            requiredAuth: true
        },
        component: () => import('../views/user/QueryBox.vue'),
    },
    {
        path: '/activity_mall_record',
        name: 'activity_mall_record',
        meta: {
            title: '活动币发放记录',
            requiredAuth: true
        },
        component: () => import('../views/user/ActivityMallRecord'),
    },
    {
        path: '/activity_mall_log',
        name: 'activity_mall_log',
        meta: {
            title: '活动币使用日志',
            requiredAuth: true
        },
        component: () => import('../views/user/ActivityMallLog'),
    },
    {
        path: '/user_score_rule',
        name: 'user_score_rule',
        meta: {
            title: '等级积分规则',
            requiredAuth: true
        },
        component: () => import('../views/scorerule/UserScoreRule.vue'),
    },
    {
        path: '/user_exp_rule',
        name: 'user_exp_rule',
        meta: {
            title: '等级经验规则',
            requiredAuth: true
        },
        component: () => import('../views/exprule/UserExpRule.vue'),
    },
    {
        path: '/settlements',
        name: 'settlements',
        meta: {
            title: '渠道提现',
            requiredAuth: true
        },
        component: () => import('../views/user/Settlements.vue'),
    },
    {
        path: '/user_level_merge',
        name: 'user_level_merge',
        meta: {
            title: '等级合并',
            requiredAuth: true
        },
        component: () => import('../views/user/UserLevelMerge'),
    },
    {
        path: '/account_balance_record',
        name: 'account_balance_record',
        meta: {
            title: '余额日志记录',
            requiredAuth: true
        },
        component: () => import('../views/user/AccountBalanceRecord'),
    },
    {
        path: '/user_forbid',
        name: 'user_forbid',
        meta: {
            title: '用户禁止操作',
            requiredAuth: true
        },
        component: () => import('../views/user/UserForbid'),
    },
    {
        path: '/user_forbid_recharge',
        name: 'user_forbid_recharge',
        meta: {
            title: '黑名单禁止充值',
            requiredAuth: true
        },
        component: () => import('../views/user/UserForbidRecharge'),
    },
    {
        path: '/water_control',
        name: 'water_control',
        meta: {
            title: '战力查看',
            requiredAuth: true
        },
        component: () => import('../views/watercontrol/WaterControl.vue'),
    },
    {
        path: '/user_ip_logs',
        name: 'user_ip_logs',
        meta: {
            title: 'IP查询',
            requiredAuth: true
        },
        component: () => import('../views/user/UserIpLogs'),
    },
    {
        path: '/user_anchors',
        name: 'user_anchors',
        meta: {
            title: '主播下级管理',
            requiredAuth: true
        },
        component: () => import('../views/user/UserAnchors'),
    },
    {
        path: '/user_sign_in',
        name: 'user_sign_in',
        meta: {
            title: '用户签到设置',
            requiredAuth: true
        },
        component: () => import('../views/user/UserSignIn'),
    },
    {
        path: '/user_transaction_link',
        name: 'user_transaction_link',
        meta: {
            title: '交易链接封禁',
            requiredAuth: true
        },
        component: () => import('../views/user/UserTransactionLink'),
    },
    {
        path: '/user_transaction_query',
        name: 'user_transaction_query',
        meta: {
            title: '交易链接查询',
            requiredAuth: true
        },
        component: () => import('../views/user/UserTransactionLinkQuery'),
    },
    {
        path: '/user_transaction_unseal',
        name: 'user_transaction_unseal',
        meta: {
            title: 'ig链接解封',
            requiredAuth: true
        },
        component: () => import('../views/user/UserTransactionUnseal'),
    },
    {
        path: '/user_limit_consumption',
        name: 'user_limit_consumption',
        meta: {
            title: '用户限制消费',
            requiredAuth: true
        },
        component: () => import('../views/user/UserLimitConsumption'),
    },
    {
        path: '/add_anchor',
        name: 'add_anchor',
        meta: {
            title: '设置主播',
            requiredAuth: true
        },
        component: () => import('../views/user/AddAnchor'),
    },
    {
        path: '/customer_service',
        name: 'customer_service',
        meta: {
            title: '专属客服',
            requiredAuth: true
        },
        component: () => import('../views/user/CustomerService'),
    },
    {
        path: '/query_real_name',
        name: 'query_real_name',
        meta: {
            title: '实名认证',
            requiredAuth: true
        },
        component: () => import('../views/user/QueryRealName'),
    },
    {
        path: '/face_recognition',
        name: 'face_recognition',
        meta: {
            title: '人脸识别限制',
            requiredAuth: true
        },
        component: () => import('../views/user/FaceRecognition'),
    },
    {
        path: '/extract_m9',
        name: 'extract_m9',
        meta: {
            title: 'M9提取记录',
            requiredAuth: true
        },
        component: () => import('../views/user/ExtractM9'),
    },
    {
        path: '/transfer',
        name: 'transfer',
        meta: {
            title: '转赠',
            requiredAuth: true
        },
        component: () => import('../views/user/Transfer'),
    },
// 订单管理
    {
        path: '/order',
        name: 'order',
        meta: {
            title: '取回/出售订单',
            requiredAuth: true
        },
        component: () => import('../views/order/Order.vue'),
    },
    {
        path: '/shop_order',
        name: 'shop_order',
        meta: {
            title: '商城订单',
            requiredAuth: true
        },
        component: () => import('../views/order/Shop.vue'),
    },
    {
        path: '/raffle',
        name: 'raffle',
        meta: {
            title: '购买订单',
            requiredAuth: true
        },
        component: () => import('../views/order/Raffle.vue'),
    },
    {
        path: '/goods_order',
        name: 'goods_order',
        meta: {
            title: '商品订单',
            requiredAuth: true
        },
        component: () => import('../views/order/GoodsOrders.vue'),
    },
    {
        path: '/recharge',
        name: 'recharge',
        meta: {
            title: '充值订单',
            requiredAuth: true
        },
        component: () => import('../views/order/Recharge.vue'),
    },
    {
        path: '/transaction_link_orders',
        name: 'transaction_link_orders',
        meta: {
            title: '交易链接订单',
            requiredAuth: true
        },
        component: () => import('../views/order/TransactionLinkOrders.vue'),
    },
    {
        path: '/automatic_delivery',
        name: 'automatic_delivery',
        meta: {
            title: '自动发货管理',
            requiredAuth: true
        },
        component: () => import('../views/order/AutomaticDelivery.vue'),
    },
// ROLL房管理
    {
        path: '/roll',
        name: 'roll',
        meta: {
            title: 'ROLL房管理',
            requiredAuth: true
        },
        component: () => import('../views/roll/RollRoom.vue'),
    },
    {
        path: '/roll/:id',
        name: 'roll_details',
        meta: {
            title: 'roll房详情',
            requiredAuth: true
        },
        props: true,
        component: () => import('../views/roll/RoomDetail.vue'),
    },
    {
        path: '/roll_activity',
        name: 'roll_activity',
        meta: {
            title: 'ROLL房活动管理',
            requiredAuth: true
        },
        component: () => import('../views/roll/RollActivity.vue'),
    },
    {
        path: '/roll_activity/:id',
        name: 'roll_prize',
        meta: {
            title: 'ROLL房活动奖品',
            requiredAuth: true
        },
        props: true,
        component: () => import('../views/roll/RollAcitvityDetail.vue'),
    },
// 热血盲盒管理
    {
        path: '/battle_manage',
        name: 'battle_manage',
        meta: {
            title: '热血盲盒管理',
            requiredAuth: true
        },
        component: () => import('../views/battle/BattleManage'),
    },
    {
        path: '/random_box',
        name: 'random_box',
        meta: {
            title: '随机盒子配置',
            requiredAuth: true
        },
        component: () => import('../views/battle/RandomBox'),
    },
    {
        path: '/blind_seeds',
        name: 'blind_seeds',
        meta: {
            title: '对战种子',
            requiredAuth: true
        },
        component: () => import('../views/battle/BlindSeeds'),
    },
    {
        path: '/random_room_log',
        name: 'random_room_log',
        meta: {
            title: '随机房间记录',
            requiredAuth: true
        },
        component: () => import('../views/battle/RandomRoomLog'),
    },
    {
        path: '/battle_user_data',
        name: 'battle_user_data',
        meta: {
            title: '用户数据',
            requiredAuth: true
        },
        component: () => import('../views/battle/BattleUserData'),
    },
    {
        path: '/battle_room_data',
        name: 'battle_room_data',
        meta: {
            title: '房间数据',
            requiredAuth: true
        },
        component: () => import('../views/battle/BattleRoomData'),
    },
    {
        path: '/battle_box_data',
        name: 'battle_box_data',
        meta: {
            title: '盒子数据',
            requiredAuth: true
        },
        component: () => import('../views/battle/BattleBoxData'),
    },
    {
        path: '/battle_caton_room',
        name: 'battle_caton_room',
        meta: {
            title: '卡顿房间',
            requiredAuth: true
        },
        component: () => import('../views/battle/BattleCatonRoom'),
    },
// 盒子/饰品升级
    {
        path: '/upgrade_boxList',
        name: 'upgrade_boxList',
        meta: {
            title: '盒子列表(升级)',
            requiredAuth: true
        },
        component: () => import('../views/lucky_upgrade/UpgradeBoxList.vue'),
    },
    {
        path: '/upgrade_details',
        name: 'upgrade_details',
        meta: {
            title: '详情升级情况',
            requiredAuth: true
        },
        component: () => import('../views/lucky_upgrade/UpgradeDetails.vue'),
    },
    {
        path: '/upgrade_box_data',
        name: 'upgrade_box_data',
        meta: {
            title: '盒子数据(升级)',
            requiredAuth: true
        },
        component: () => import('../views/lucky_upgrade/UpgradeBoxData.vue'),
    },
    {
        path: '/upgrade_user_data',
        name: 'upgrade_user_data',
        meta: {
            title: '用户数据(升级)',
            requiredAuth: true
        },
        component: () => import('../views/lucky_upgrade/UpgradeUserData.vue'),
    },
    {
        path: '/upgrade_guaranteed_goods',
        name: 'upgrade_guaranteed_goods',
        meta: {
            title: '保底饰品(升级)',
            requiredAuth: true
        },
        component: () => import('../views/lucky_upgrade/UpgradeGuaranteedGoods.vue'),
    },
// 战团管理
    {
        path: '/battle_groups',
        name: 'battle_groups',
        meta: {
            title: '战团管理',
            requiredAuth: true
        },
        component: () => import('../views/battle_groups/BattleGroups.vue'),
    },
    {
        path: '/battle_user',
        name: 'battle_user',
        meta: {
            title: '成员列表',
            requiredAuth: true
        },
        component: () => import('../views/battle_groups/BattleUser.vue'),
    },
    {
        path: '/battle_bonus',
        name: 'battle_bonus',
        meta: {
            // title: '战团配置',
            title: '公共参数配置',
            requiredAuth: true
        },
        component: () => import('../views/battle_groups/BattleBonus.vue'),
    },
    {
        path: '/battle_objective',
        name: 'battle_objective',
        meta: {
            title: '宗旨审核',
            requiredAuth: true
        },
        component: () => import('../views/battle_groups/BattleObjective.vue'),
    },
    {
        path: '/integral_goods',
        name: 'integral_goods',
        meta: {
            title: '积分商品',
            requiredAuth: true
        },
        component: () => import('../views/battle_groups/IntegralGoods.vue'),
    },
// 优惠券管理
    {
        path: '/coupon',
        name: 'coupon',
        meta: {
            title: '优惠券配置',
            requiredAuth: true
        },
        component: () => import('../views/coupon/Coupon.vue'),
    },
    {
        path: '/coupon_log',
        name: 'coupon_log',
        meta: {
            title: '优惠券记录',
            requiredAuth: true
        },
        component: () => import('../views/coupon/CouponLog.vue'),
    },
// 会员卡管理
    {
        path: '/vip_card',
        name: 'vip_card',
        meta: {
            title: '会员卡配置',
            requiredAuth: true
        },
        component: () => import('../views/vip/VipCard.vue'),
    },
    {
        path: '/vip_user',
        name: 'vip_user',
        meta: {
            title: '会员用户表',
            requiredAuth: true
        },
        component: () => import('../views/vip/VipUser.vue'),
    },
    {
        path: '/vip_log',
        name: 'vip_log',
        meta: {
            title: '会员卡领取记录',
            requiredAuth: true
        },
        component: () => import('../views/vip/VipLog.vue'),
    },
// 福利中心
// 福利中心-任务管理
    {
        path: '/task',
        name: 'task',
        meta: {
            title: '任务管理',
            requiredAuth: true
        },
        component: () => import('../views/welfare_center/task/Task.vue'),
    },
    {
        path: '/task_log',
        name: 'task_log',
        meta: {
            title: '任务记录',
            requiredAuth: true
        },
        component: () => import('../views/welfare_center/task/TaskLog.vue'),
    },
// 福利中心-新人充值管理
    {
        path: '/new_user_recharge',
        name: 'new_user_recharge',
        meta: {
            title: '新人充值管理',
            requiredAuth: true
        },
        component: () => import('../views/welfare_center/new_user/NewUserRecharge.vue'),
    },
// 工单管理
    {
        path: '/repair_order',
        name: 'repair_order',
        meta: {
            title: '工单管理',
            requiredAuth: true
        },
        component: () => import('../views/repairorder/RepairOrder.vue'),
    },
// 文案管理
    {
        path: '/system_mail',
        name: 'system_mail',
        meta: {
            title: '站内消息',
            requiredAuth: true
        },
        component: () => import('../views/message/SystemMail.vue'),
    },
    {
        path: '/system_mail_detail/:id',
        name: 'system_mail_detail',
        meta: {
            title: '站内消息详情',
            requiredAuth: true
        },
        component: () => import('../views/message/SystemMailDetail.vue'),
    },
    {
        path: '/message',
        name: 'message',
        meta: {
            title: '网站公告',
            requiredAuth: true
        },
        component: () => import('../views/message/Message.vue'),
    },
    {
        path: '/article',
        name: 'article',
        meta: {
            title: '文章管理',
            requiredAuth: true
        },
        component: () => import('../views/article/Articles.vue'),
    },
    {
        path: '/article/create',
        name: 'article_create',
        meta: {
            title: '新建文章',
            requiredAuth: true
        },
        component: () => import('../views/article/ArticleEdit.vue'),
    },
    {
        path: '/article/edit/:article_id',
        name: 'article_edit',
        meta: {
            title: '编辑文章',
            requiredAuth: true
        },
        props: true,
        component: () => import('../views/article/ArticleEdit.vue'),
    },
    {
        path: '/article/detail/:article_id',
        name: 'article_detail',
        meta: {
            title: '文章详情',
            requiredAuth: true
        },
        props: true,
        component: () => import('../views/article/ArticleDetail.vue'),
    },
// 红包管理
    {
        path: '/password_red_packet',
        name: 'password_red_packet',
        meta: {
            title: '口令红包',
            requiredAuth: true
        },
        component: () => import('../views/redpacket/PasswordRedPacket'),
    },
    {
        path: '/password_packets/:id',
        name: 'password_packets_details',
        meta: {
            title: '口令列表',
            requiredAuth: true
        },
        component: () => import('../views/redpacket/PasswordPackets'),
    },
    {
        path: '/inherit_red_envelope',
        name: 'inherit_red_envelope',
        meta: {
            title: '继承红包',
            requiredAuth: true
        },
        component: () => import('../views/redpacket/InheritRedEnvelope'),
    },
    {
        path: '/welfare_red_envelope',
        name: 'welfare_red_envelope',
        meta: {
            title: '福利红包',
            requiredAuth: true
        },
        component: () => import('../views/redpacket/WelfareRedEnvelope'),
    },
    {
        path: '/red_envelope_editor',
        name: 'red_envelope_editor',
        meta: {
            title: '红包编辑',
            requiredAuth: true
        },
        component: () => import('../views/redpacket/RedEnvelopeEditor.vue'),
    },
    {
        path: '/accumulated_topup_conditions',
        name: 'accumulated_topup_conditions',
        meta: {
            title: '累充红包条件',
            requiredAuth: true
        },
        component: () => import('../views/redpacket/AccumulatedTopUpConditions.vue'),
    },
// 活动管理
// 活动管理-转盘活动
    {
        path: '/rotary_activities_config',
        name: 'rotary_activities_config',
        meta: {
            title: '转盘活动配置',
            requiredAuth: true
        },
        component: () => import('../views/activities/rotary/RotaryActivitiesConfig.vue'),
    },
    {
        path: '/rotary_activities',
        name: 'rotary_activities',
        meta: {
            title: '转盘中奖记录',
            requiredAuth: true
        },
        component: () => import('../views/activities/rotary/RotaryActivities.vue'),
    },
    {
        path: '/rotary_activities_rank',
        name: 'rotary_activities_rank',
        meta: {
            title: '转盘排行榜',
            requiredAuth: true
        },
        component: () => import('../views/activities/rotary/RotaryActivitiesRank.vue'),
    },
// 活动管理-端午活动
    {
        path: '/dragon_boat_config',
        name: 'dragon_boat_config',
        meta: {
            title: '端午活动配置',
            requiredAuth: true
        },
        component: () => import('../views/activities/dragon_boat_festival/DragonBoatConfig.vue'),
    },
// 活动管理-碎片活动
    {
        path: '/debirs_group',
        name: 'debirs_group',
        meta: {
            title: '碎片分组',
            requiredAuth: true
        },
        component: () => import('../views/debris_activity/DebirsGroup.vue'),
    },
    {
        path: '/debris_config',
        name: 'debris_config',
        meta: {
            title: '碎片配置',
            requiredAuth: true
        },
        component: () => import('../views/debris_activity/DebrisConfig.vue'),
    },
    {
        path: '/debris_formula_config',
        name: 'debris_formula_config',
        meta: {
            title: '公式配置',
            requiredAuth: true
        },
        component: () => import('../views/debris_activity/DebrisFormulaConfig.vue'),
    },
    {
        path: '/debris_box_config',
        name: 'debris_box_config',
        meta: {
            title: '碎片盒子配置',
            requiredAuth: true
        },
        component: () => import('../views/debris_activity/DebrisBoxConfig.vue'),
    },
// 活动管理-秒杀活动
    {
        path: '/seckill',
        name: 'seckill',
        meta: {
            title: '秒杀管理',
            requiredAuth: true
        },
        component: () => import('../views/seckill/Seckill.vue'),
    },
// 活动管理-战队投票
    {
        path: '/voting_quiz',
        name: 'voting_quiz',
        meta: {
            title: '投票管理',
            requiredAuth: true
        },
        component: () => import('../views/votingquiz/VotingQuiz.vue'),
    },
// 活动管理-眉笔活动
    {
        path: '/unluck_battle_config',
        name: 'unluck_battle_config',
        meta: {
            title: '热血盲盒眉笔',
            requiredAuth: true
        },
        component: () => import('../views/activities/unlucky/UnluckBattleConfig.vue'),
    },
// {
//   path: '/unluck_upgrade_config',
//   name: 'unluck_upgrade_config',
//   meta: {
//     title: '幸运升级眉笔',
//     requiredAuth: true
//   },
//   component: () => import('../views/activities/unlucky/UnluckUpgradeConfig.vue'),
// },
// 活动管理-推广活动
    {
        path: '/partner_config',
        name: 'partner_config',
        meta: {
            title: '推广活动管理',
            requiredAuth: true
        },
        component: () => import('../views/activities/partner/PartnerConfig.vue'),
    },
    {
        path: '/partner_prize',
        name: 'partner_prize',
        meta: {
            title: '推广活动奖品',
            requiredAuth: true
        },
        component: () => import('../views/activities/partner/PartnerPrize.vue'),
    },
// 活动管理-新年活动
    {
        path: '/new_year_config',
        name: 'new_year_config',
        meta: {
            title: '新年活动管理',
            requiredAuth: true
        },
        component: () => import('../views/activities/new_year/NewYearConfig.vue'),
    },
// 头像/名字审核
// 头像管理
    {
        path: '/examine_avatar',
        name: 'examine_avatar',
        meta: {
            title: '头像管理',
            requiredAuth: true
        },
        component: () => import('../views/examine/ExamineAvatar'),
    },
//名字审核
    {
        path: '/examine_name',
        name: 'examine_name',
        meta: {
            title: '名字审核',
            requiredAuth: true
        },
        component: () => import('../views/examine/ExamineName'),
    },
// 数据统计
    {
        path: '/recharge_statistic',
        name: 'recharge_statistic',
        meta: {
            title: '充值统计',
            requiredAuth: true
        },
        component: () => import('../views/statistical/RechargeStatistic.vue'),
    },
    {
        path: '/retrieve_or_shop_statistic',
        name: 'retrieve_or_shop_statistic',
        meta: {
            title: '取回/商城统计',
            requiredAuth: true
        },
        component: () => import('../views/statistical/RetrieveOrShopStatistic.vue'),
    },
    {
        path: '/lottery_statistic',
        name: 'lottery_statistic',
        meta: {
            title: '抽奖统计',
            requiredAuth: true
        },
        component: () => import('../views/statistical/LotteryStatistic.vue'),
    },
    {
        path: '/battle_statistics',
        name: 'battle_statistics',
        meta: {
            title: '对战统计',
            requiredAuth: true
        },
        component: () => import('../views/statistical/BattleStatistics.vue'),
    },
    {
        path: '/user_statistic',
        name: 'user_statistic',
        meta: {
            title: '用户查询',
            requiredAuth: true
        },
        component: () => import('../views/statistical/UserStatistic.vue'),
    },
//配置页面
    {
        path: '/config',
        name: 'config',
        meta: {
            title: 'qq群与客服配置',
            requiredAuth: true
        },
        component: () => import('../views/config/Config.vue'),
    },
//权限管理页面
    {
        path: '/permission',
        name: 'permission',
        meta: {
            title: '权限管理',
            requiredAuth: true
        },
        component: () => import('../views/permission/Permission.vue'),
    },
    {
        path: '/action_log',
        name: 'action_log',
        meta: {
            title: '行为日志',
            requiredAuth: true
        },
        component: () => import('../views/permission/ActionLog.vue'),
    },
    // 废弃路由
    // {
    // 	path: '/trade',
    // 	name: 'trade',
    // 	meta: {
    // 		title: '赠送订单',
    // 		requiredAuth: true
    // 	},
    // 	component: () => import('../views/order/Trade.vue'),
    // },
    // {
    // 	path: '/password_packets_all',
    // 	name: 'password_packets_all',
    // 	meta: {
    // 		title: '全局搜索口令',
    // 		requiredAuth: true
    // 	},
    // 	component: () => import('../views/redpacket/PasswordPacketsAll'),
    // },
    // {
    // 	path: '/zbt_prize',
    // 	name: 'zbt_prize',
    // 	meta: {
    // 		title: '扎比特饰品',
    // 		requiredAuth: true
    // 	},
    // 	component: () => import('../views/zbtprize/ZbtPrize.vue'),
    // },
]
